<template>
  <div class="brand-filter">
    <div class="filter-header">
      <h3>Brands</h3>
      <button 
        v-if="selectedBrand" 
        @click="clearFilter"
        class="clear-btn"
      >
        Clear
      </button>
    </div>
    
    <div class="brands">
      <button
        v-for="brand in brands"
        :key="brand.id"
        @click="selectBrand(brand.id)"
        :class="['brand-btn', { active: selectedBrand === brand.id }]"
      >
        {{ brand.name }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BrandFilter',
  computed: {
    ...mapState({
      brands: state => state.ecommerce.products.brands,
      selectedBrand: state => state.ecommerce.products.selectedBrand
    })
  },
  methods: {
    selectBrand(brandId) {
      const newBrand = this.selectedBrand === brandId ? null : brandId
      this.$store.dispatch('ecommerce/products/updateBrandFilter', newBrand)
    },
    clearFilter() {
      this.$store.dispatch('ecommerce/products/updateBrandFilter', null)
    }
  }
}
</script>

<style scoped>
.brand-filter {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-top: 20px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.filter-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.clear-btn {
  background: none;
  border: 1px solid #ddd;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
}

.clear-btn:hover {
  background: #f8f9fa;
  border-color: #999;
}

.brands {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.brand-btn {
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
  transition: all 0.3s ease;
}

.brand-btn:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.brand-btn.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}
</style>